{
  "supportUrl": "https://ko-fi.com/ethanyu",
  "productUrl": "https://ko-fi.com/s/dc15874c46",
  "adsensePublisherId": "ca-pub-9204374058318949",
  "adsensePlacement": {
    "adUnitId": "4079591556",
    "path": "/relay-to-n8n/",
    "position": "after-site-footer",
    "enabled": false
  }
}
